import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductSwitchService {
  private productCodeSource = new BehaviorSubject<any>(null);

  productVariantCode$ = this.productCodeSource.asObservable();

  updateProductCode(variantResp) {
    this.productCodeSource.next(variantResp);
  }
}
